import React, { FunctionComponent } from "react";

import { Display, Layout, SpacingSize } from "@multiweb/reactComponents";

/** Layoutová komponenta definující odsazení pro nadpisy skupin v sekci Rychlý přístup. */
export const QuickAccessGroupHeaderLayout: FunctionComponent = ({ children }) => (
    <Layout
        spacingSizeTop={SpacingSize.m}
        spacingSizeBottom={SpacingSize.xxs}
        spacingSizeLeft={SpacingSize.m}
        display={Display.block}
    >
        {children}
    </Layout>
);
